export default __webpack_public_path__ + "static/media/definix-overview-th.e97a4b1d.png";